import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Home, Briefcase, HardHat, MessageSquare, User, LayoutDashboard, LogIn, PlusCircle } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import { useWebSocket } from '../../context/WebSocketContext';

export const MobileBottomNav = () => {
  const { t } = useTranslation();
  const { user, isAdmin } = useAuth();
  const { unreadCount } = useWebSocket();
  const { pathname } = useLocation();

  const items = user
    ? [
        { to: '/', label: t('nav.home'), icon: Home, id: 'home' },
        { to: '/jobs', label: t('nav.jobs'), icon: Briefcase, id: 'jobs' },
        user.user_type !== 'contractor'
          ? { to: '/dashboard/post-job', label: 'Publier', icon: PlusCircle, id: 'post', accent: true }
          : { to: '/contractors', label: t('nav.contractors'), icon: HardHat, id: 'contractors' },
        { to: '/dashboard/messages', label: t('nav.messages'), icon: MessageSquare, id: 'messages', badge: unreadCount },
        isAdmin
          ? { to: '/admin', label: t('nav.admin'), icon: LayoutDashboard, id: 'admin' }
          : { to: '/dashboard', label: t('nav.dashboard'), icon: User, id: 'dashboard' },
      ]
    : [
        { to: '/', label: t('nav.home'), icon: Home, id: 'home' },
        { to: '/jobs', label: t('nav.jobs'), icon: Briefcase, id: 'jobs' },
        { to: '/contractors', label: t('nav.contractors'), icon: HardHat, id: 'contractors' },
        { to: '/login', label: t('nav.login'), icon: LogIn, id: 'login' },
      ];

  const isActive = (to) => (to === '/' ? pathname === '/' : pathname.startsWith(to));

  return (
    <nav
      className="md:hidden fixed bottom-0 inset-x-0 z-50 bg-white/95 backdrop-blur border-t border-[#1E3A8A]/10 shadow-[0_-4px_16px_rgba(0,0,0,0.06)]"
      style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}
      data-testid="mobile-bottom-nav"
    >
      <ul className="flex items-stretch justify-around h-16">
        {items.map(({ to, label, icon: Icon, id, badge, accent }) => {
          const active = isActive(to);
          return (
            <li key={id} className="flex-1">
              <Link
                to={to}
                className={`relative flex flex-col items-center justify-center h-full gap-0.5 text-[11px] font-medium transition-colors ${active ? 'text-[#1E3A8A]' : 'text-[#6B7280]'}`}
                data-testid={`bottom-nav-${id}`}
              >
                {accent ? (
                  <span className="flex items-center justify-center w-10 h-10 -mt-5 rounded-full bg-[#F59E0B] text-white shadow-lg">
                    <Icon className="w-5 h-5" />
                  </span>
                ) : (
                  <Icon className={`w-5 h-5 ${active ? 'stroke-[2.5]' : ''}`} />
                )}
                <span>{label}</span>
                {badge > 0 && (
                  <span className="absolute top-2 right-1/2 translate-x-4 min-w-[16px] h-4 px-1 rounded-full bg-[#F59E0B] text-white text-[10px] font-bold flex items-center justify-center" data-testid="bottom-nav-messages-badge">
                    {badge > 99 ? '99+' : badge}
                  </span>
                )}
                {active && !accent && <span className="absolute top-0 w-8 h-0.5 rounded-full bg-[#1E3A8A]" />}
              </Link>
            </li>
          );
        })}
      </ul>
    </nav>
  );
};
